import Phaser from 'phaser';
import { HEADER_HEIGHT } from '../config';
import { COLORS, TextStyles, Spacing } from '../ui/theme';
import { store } from '../state/store';
import { events } from '../state/events';
import { Arrow } from '../ui/Arrow';
import { CheckButton } from '../ui/CheckButton';

const BAKER_KEYS = [
  'baker-character1-a', 'baker-character1-b', 'baker-character1-c', 'baker-character1-d',
  'baker-character1-e', 'baker-character1-f', 'baker-character1-g', 'baker-character1-h',
  'baker-character1-i', 'baker-character1-j', 'baker-character1-k', 'baker-character1-l',
  'baker-character1-m',
];

export class WelcomeScene extends Phaser.Scene {
  private baker!: Phaser.GameObjects.Image;
  private index = 0;

  constructor() {
    super({ key: 'Welcome' });
  }

  create(): void {
    const w = this.scale.width;
    const h = this.scale.height;

    this.cameras.main.setBackgroundColor(COLORS.bgLavender);

    if (!this.scene.isActive('HeaderBar')) this.scene.launch('HeaderBar');
    this.scene.bringToTop('HeaderBar');

    const titleY = HEADER_HEIGHT + Spacing.xxl * 2 + Spacing.md;
    this.add.text(w / 2, titleY, 'WELCOME TO BAKERY PRO', TextStyles.TITLE).setOrigin(0.5);
    this.add.text(w / 2, titleY + 88, 'Choose your baker...', TextStyles.SUBTITLE).setOrigin(0.5);

    this.index = Phaser.Math.Clamp(store.state.bakerCostume, 0, BAKER_KEYS.length - 1);
    this.baker = this.add.image(w / 2, h / 2 + 120, BAKER_KEYS[this.index]).setOrigin(0.5, 0.5);
    this.fitBaker();

    const arrowY = h / 2 + 120;
    new Arrow(this, w / 2 - 320, arrowY, { direction: 'left',  size: 180, onClick: () => this.changeBaker(-1) });
    new Arrow(this, w / 2 + 320, arrowY, { direction: 'right', size: 180, onClick: () => this.changeBaker(+1) });

    new CheckButton(this, w - 140, h - 130, { size: 140, onClick: () => this.confirm() });

    this.add.text(w / 2, h - 48, 'Tap the arrows to switch  •  tap the check to start', TextStyles.HINT).setOrigin(0.5);

    events.on('baker:changed', ({ costume }) => {
      if (costume === this.index) return;
      this.index = costume;
      this.baker.setTexture(BAKER_KEYS[costume]);
      this.fitBaker();
    });
  }

  private fitBaker(): void {
    const maxH = this.scale.height * 0.52;
    const scale = maxH / this.baker.height;
    this.baker.setScale(Math.min(1.2, scale));
  }

  private changeBaker(delta: number): void {
    this.index = (this.index + delta + BAKER_KEYS.length) % BAKER_KEYS.length;
    this.baker.setTexture(BAKER_KEYS[this.index]);
    this.fitBaker();
    store.setBaker(this.index);
  }

  private confirm(): void {
    store.setBaker(this.index);
    // The day starts in the Kitchen: recipes are chosen from the recipe book
    // there, and the menu board fills up as batches are made.
    this.scene.start('Kitchen');
  }
}
